import random from './random';

export function riffleShuffle<T>(array: T[]) {
  const output: T[] = [];
  const halfOrLess = Math.floor(array.length / 2);
  const isOdd = array.length % 2;

  // clone the array and split into two halves
  let i = array.length;
  const right = [...array];
  const left = right.splice(0, halfOrLess);

  // push random elements from each half of the array
  i = halfOrLess + 1;

  while (--i) {
    output.push(right.splice(Math.floor(random() * (i + isOdd)), 1)[0]);
    output.push(left.splice(Math.floor(random() * i), 1)[0]);
  }

  // if odd number of elements, push the element left behind
  if (isOdd) {
    output.push(right.splice(0, 1)[0]);
  }

  return output;
}

/**
 * Fisher-Yates shuffle from https://stackoverflow.com/a/6274398/
 *
 * @param  {array} array - array to shuffle
 * @return {array}       - shuffled array
 */
export function shuffle<T>(array: T[]): T[] {
  let counter = array.length;
  let index: number;
  let temp: T;

  // While there are elements in the array
  while (counter > 0) {
    // Pick a random index
    // FIXME verify random behavior when no seed is set
    // index = Math.floor(random() * counter);
    index = Math.floor(Math.random() * counter);

    // Decrease counter by 1
    counter--;

    // And swap the last element with it
    temp = array[counter];
    array[counter] = array[index];
    array[index] = temp;
  }

  return array;
}

export default shuffle;
